import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getUsageHistory } from '../../services'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import {
	GetUsageHistoryRequest,
	GetUsageHistoryResponse,
} from '@/modules/batches/type'

export default function useQueryGetUsageHistory(
	payload: GetUsageHistoryRequest,
	props?: UseBaseQueryOptions<GetUsageHistoryResponse>,
) {
	return useQuery({
		queryKey: [BatchesQueryKeys.GetUsageHistory, payload],
		queryFn: () => getUsageHistory(payload),
		...props,
	})
}
